module.exports = __webpack_public_path__ + "img/default-avatar-img.3c6404cf.png";